export default "__VITE_ASSET__Bjg3TZSx__"